export const WPAdmin = (function () {
	'use strict';

    function addAdminItem () {
        const admin_list = $( '#wp-admin-bar-root-default' );
        const default_copy = 'CQ&nbsp;fluency';

        // @todo - fetch text field from WP

        let list_item_html = `
            <li class="admin-cq-item">
                <a id="admin-cq-copy"> "CQ Fluency" (Copy to clipboard) </a>
            </li>
        `;

        $( admin_list ).append( list_item_html );

        $( '#admin-cq-copy' ).attr( 'href', default_copy );
    }

    function copyToClipboard () {
        $( '#admin-cq-copy' ).click(function ( e ) { 
            e.preventDefault();

            const clipboard_text = $( this ).attr( 'href' );

            document.addEventListener('copy', function(e) {
                e.clipboardData.setData('text/plain', clipboard_text);
                e.preventDefault();
            }, true);

            document.execCommand('copy'); 
            alert('copied text: ' + clipboard_text);
        });
    }

	function init() {
        addAdminItem();
        copyToClipboard();
	}

	return {
		init: init,
	};
})();